<template>
  <TavernFlipCoinBigButton :label="$t('coinPusherTimerText') + ':'" :disabled="true" class="pusher-timer-button">
    <TavernPusherTimer />
  </TavernFlipCoinBigButton>
</template>

<style scoped lang="scss">
.pusher-timer-button {
  opacity: 1;
  color: var(--main-text-color);
  flex-direction: column;
  height: 62px;
  padding: 16px;
}
</style>

<style lang="scss">
.pusher-timer-button.gradient-button {
  min-width: 217px;
}
</style>
